export default __webpack_public_path__ + "static/media/icon-saas-active.ef9c9a5f.svg";